export const strToSlug = (str = '') =>
	str
		.trim()
		.toLowerCase()
		.replace(/['.#,"\u200B-\u200D\uFEFF]/g, '')
		.replace(/[ ]/g, '-');

export const strListToPath = (strList: string[] = ['']) => strToSlug(strList.join('/'));
